import { useStore } from "zustand";
import { createStore } from "zustand/vanilla";

interface ISmartSearch {
  isSmartSearchEnabled: boolean;
  isSmartSearchFromTechnologyOverview: boolean;
  setIsSmartSearchEnabled: (smartSearchEnabled: boolean) => void;
  setIsSmartSearchFromTechnologyOverview: (isSmartSearchFromTechnologyOverview: boolean) => void; // Add this line
  setSmartSearchDescription: (smartSearchDescription: string) => void;
  setTechnologyDescription: (technologyDescription: null | string | undefined) => void;
  smartSearchDescription: string;
  technologyDescription: null | string | undefined;
}

const SmartSearchStore = createStore<ISmartSearch>((set) => ({
  isSmartSearchEnabled: localStorage.getItem("isSmartSearchEnabled") === "true",
  isSmartSearchFromTechnologyOverview: false,
  setIsSmartSearchEnabled: (isSmartSearchEnabled) => set({ isSmartSearchEnabled }),
  setIsSmartSearchFromTechnologyOverview: (
    isSmartSearchFromTechnologyOverview: boolean, // Specify the type here
  ) => set({ isSmartSearchFromTechnologyOverview }),
  setSmartSearchDescription: (smartSearchDescription: string) => set({ smartSearchDescription }),
  setTechnologyDescription: (technologyDescription: null | string | undefined) => set({ technologyDescription }),
  smartSearchDescription: "",
  technologyDescription: "",
}));

function useSmartSearchStore(): ISmartSearch;
function useSmartSearchStore<Type>(selector: (state: ISmartSearch) => Type): Type;
function useSmartSearchStore<Type>(selector?: (state: ISmartSearch) => Type) {
  return useStore(SmartSearchStore, selector!);
}

export const ClearSmartSearchStore = () => {
  localStorage.setItem("isSmartSearchEnabled", "false");
  SmartSearchStore.setState({
    isSmartSearchEnabled: false,
    isSmartSearchFromTechnologyOverview: false,
    smartSearchDescription: "",
    technologyDescription: "",
  });
};

export default useSmartSearchStore;
